<template>
  <div class="sg-wrap" ref="wrap">
    <!-- Score bar -->
    <div class="sg-topbar">
      <div class="sg-stat-pill">
        <span class="sg-stat-icon">🎯</span>
        <span class="sg-stat-val">{{ score }}</span>
        <span class="sg-stat-lbl">score</span>
      </div>
      <div class="sg-title">🐍 Snake</div>
      <div class="sg-stat-pill sg-stat-right">
        <span class="sg-stat-icon">⭐</span>
        <span class="sg-stat-val">{{ best }}</span>
        <span class="sg-stat-lbl">best</span>
      </div>
    </div>

    <!-- Level bar -->
    <div v-if="running" class="sg-level-bar">
      <span class="sg-level-txt">LEVEL {{ level }}</span>
      <div class="sg-level-track"><div class="sg-level-fill" :style="{ width: ((score % 5) / 5 * 100) + '%' }"></div></div>
    </div>

    <!-- Board -->
    <div class="sg-board-wrap" ref="boardWrap">
      <canvas ref="canvas" class="sg-canvas"></canvas>

      <transition name="sg-fade">
        <div v-if="!running && !over" class="sg-overlay">
          <div class="sg-ov-card">
            <div class="sg-ov-emoji">🐍</div>
            <h2 class="sg-ov-title">Snake</h2>
            <p class="sg-ov-hint">Arrow keys / WASD / D-pad below</p>
            <button class="sg-start-btn" @click="startGame">▶ Play Now</button>
          </div>
        </div>
      </transition>

      <transition name="sg-fade">
        <div v-if="over" class="sg-overlay sg-over-overlay">
          <div class="sg-ov-card">
            <div class="sg-ov-emoji">{{ score >= 10 ? '🏆' : '😅' }}</div>
            <h2 class="sg-ov-title">{{ score >= 10 ? 'Amazing!' : 'Game Over' }}</h2>
            <div class="sg-final-score">{{ score }} <span>pts</span></div>
            <button class="sg-start-btn" @click="startGame">↺ Play Again</button>
          </div>
        </div>
      </transition>
    </div>

    <!-- D-pad -->
    <div class="sg-dpad">
      <button class="sg-dpad-btn" @click="dir('up')">▲</button>
      <div class="sg-dpad-mid-row">
        <button class="sg-dpad-btn" @click="dir('left')">◀</button>
        <div class="sg-dpad-center">●</div>
        <button class="sg-dpad-btn" @click="dir('right')">▶</button>
      </div>
      <button class="sg-dpad-btn" @click="dir('down')">▼</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SnakeGame1',
  data() {
    return {
      score: 0, best: 0, level: 1,
      running: false, over: false,
      snake: [], food: {}, direction: 'right', nextDir: 'right',
      cols: 22, rows: 22,
      loop: null, ctx: null, cw: 0, ch: 0,
    };
  },
  mounted() {
    window.addEventListener('keydown', this.onKey);
    this.$nextTick(() => this.initCanvas());
    window.addEventListener('resize', this.onResize);
  },
  beforeDestroy() {
    window.removeEventListener('keydown', this.onKey);
    window.removeEventListener('resize', this.onResize);
    if (this.loop) clearInterval(this.loop);
  },
  methods: {
    initCanvas() {
      const bw = this.$refs.boardWrap;
      const cv = this.$refs.canvas;
      if (!bw || !cv) return;
      const size = Math.min(bw.clientWidth, bw.clientHeight) || 320;
      cv.width = size; cv.height = size;
      this.cw = size / this.cols; this.ch = size / this.rows;
      this.ctx = cv.getContext('2d');
      this.drawIdle();
    },
    onResize() { this.initCanvas(); if (this.running) this.drawFrame(); },
    drawIdle() {
      const c = this.ctx; if (!c) return;
      const cv = this.$refs.canvas;
      c.fillStyle = '#f0fdf4';
      c.fillRect(0, 0, cv.width, cv.height);
      // grid
      c.strokeStyle = 'rgba(34,197,94,0.1)';
      c.lineWidth = 0.5;
      for (let x = 0; x <= this.cols; x++) { c.beginPath(); c.moveTo(x*this.cw,0); c.lineTo(x*this.cw,cv.height); c.stroke(); }
      for (let y = 0; y <= this.rows; y++) { c.beginPath(); c.moveTo(0,y*this.ch); c.lineTo(cv.width,y*this.ch); c.stroke(); }
    },
    startGame() {
      this.over = false; this.running = true; this.score = 0; this.level = 1;
      this.direction = 'right'; this.nextDir = 'right';
      const m = Math.floor(this.cols / 2);
      this.snake = [{x:m,y:m},{x:m-1,y:m},{x:m-2,y:m}];
      this.spawnFood();
      if (this.loop) clearInterval(this.loop);
      this.loop = setInterval(this.tick, this.speed());
    },
    speed() { return Math.max(75, 200 - (this.level-1)*18); },
    tick() {
      this.direction = this.nextDir;
      const head = {...this.snake[0]};
      if (this.direction==='up') head.y--;
      else if (this.direction==='down') head.y++;
      else if (this.direction==='left') head.x--;
      else head.x++;
      if (head.x<0||head.x>=this.cols||head.y<0||head.y>=this.rows||this.snake.some(s=>s.x===head.x&&s.y===head.y)) { this.endGame(); return; }
      this.snake.unshift(head);
      if (head.x===this.food.x&&head.y===this.food.y) {
        this.score++; if (this.score>this.best) this.best=this.score;
        this.$emit('score-update',this.score);
        if (this.score%5===0) { this.level++; clearInterval(this.loop); this.loop=setInterval(this.tick,this.speed()); }
        this.spawnFood();
      } else { this.snake.pop(); }
      this.drawFrame();
    },
    spawnFood() {
      let pos;
      do { pos={x:Math.floor(Math.random()*this.cols),y:Math.floor(Math.random()*this.rows)}; }
      while (this.snake.some(s=>s.x===pos.x&&s.y===pos.y));
      this.food=pos;
    },
    drawFrame() {
      const c = this.ctx; if (!c) return;
      const cv = this.$refs.canvas;
      const cw=this.cw, ch=this.ch;
      // bg
      c.fillStyle='#f0fdf4'; c.fillRect(0,0,cv.width,cv.height);
      // grid
      c.strokeStyle='rgba(34,197,94,0.12)'; c.lineWidth=0.5;
      for (let x=0;x<=this.cols;x++){c.beginPath();c.moveTo(x*cw,0);c.lineTo(x*cw,cv.height);c.stroke();}
      for (let y=0;y<=this.rows;y++){c.beginPath();c.moveTo(0,y*ch);c.lineTo(cv.width,y*ch);c.stroke();}
      // food glow
      const fx=this.food.x*cw+cw/2, fy=this.food.y*ch+ch/2;
      const gr=c.createRadialGradient(fx,fy,0,fx,fy,cw*0.6);
      gr.addColorStop(0,'rgba(239,68,68,0.3)'); gr.addColorStop(1,'transparent');
      c.fillStyle=gr; c.fillRect(this.food.x*cw-cw,this.food.y*ch-ch,cw*3,ch*3);
      // food
      c.beginPath(); c.arc(fx,fy,cw*0.38,0,Math.PI*2);
      c.fillStyle='#ef4444'; c.fill();
      c.beginPath(); c.arc(fx-cw*0.1,fy-cw*0.12,cw*0.1,0,Math.PI*2);
      c.fillStyle='rgba(255,255,255,0.7)'; c.fill();
      // snake
      this.snake.forEach((s,i)=>{
        const x=s.x*cw+1, y=s.y*ch+1, w=cw-2, h=ch-2;
        const r=Math.min(w,h)*0.3;
        c.beginPath(); c.roundRect(x,y,w,h,r);
        if (i===0) {
          const g2=c.createLinearGradient(x,y,x+w,y+h);
          g2.addColorStop(0,'#16a34a'); g2.addColorStop(1,'#15803d');
          c.fillStyle=g2;
        } else {
          const alpha=Math.max(0.4,1-i*0.03);
          c.fillStyle=`rgba(34,197,94,${alpha})`;
        }
        c.fill();
        // head eyes
        if (i===0) {
          c.fillStyle='#fff';
          const ex=s.x*cw+cw/2, ey=s.y*ch+ch/2;
          c.beginPath(); c.arc(ex-cw*0.18,ey-ch*0.1,cw*0.1,0,Math.PI*2); c.fill();
          c.beginPath(); c.arc(ex+cw*0.18,ey-ch*0.1,cw*0.1,0,Math.PI*2); c.fill();
          c.fillStyle='#052e16';
          c.beginPath(); c.arc(ex-cw*0.18,ey-ch*0.1,cw*0.05,0,Math.PI*2); c.fill();
          c.beginPath(); c.arc(ex+cw*0.18,ey-ch*0.1,cw*0.05,0,Math.PI*2); c.fill();
        }
      });
    },
    endGame() {
      clearInterval(this.loop); this.loop=null;
      this.running=false; this.over=true;
      this.$emit('game-over',this.score);
    },
    dir(d) {
      const opp={up:'down',down:'up',left:'right',right:'left'};
      if (d!==opp[this.direction]) this.nextDir=d;
      if (!this.running&&!this.over) this.startGame();
    },
    onKey(e) {
      const map={ArrowUp:'up',w:'up',W:'up',ArrowDown:'down',s:'down',S:'down',ArrowLeft:'left',a:'left',A:'left',ArrowRight:'right',d:'right',D:'right'};
      if (map[e.key]) { e.preventDefault(); this.dir(map[e.key]); }
    },
  },
};
</script>

<style scoped>
.sg-wrap {
  width:100%; height:100%;
  display:flex; flex-direction:column;
  background:#fff;
  border-radius:10px; overflow:hidden;
}
.sg-topbar {
  display:flex; align-items:center; justify-content:space-between;
  padding:10px 16px;
  background:linear-gradient(135deg,#f0fdf4,#dcfce7);
  border-bottom:1px solid #bbf7d0;
  flex-shrink:0;
}
.sg-stat-pill { display:flex; align-items:center; gap:4px; }
.sg-stat-icon { font-size:.9rem; }
.sg-stat-val { font-size:1.1rem; font-weight:800; color:#15803d; }
.sg-stat-lbl { font-size:.65rem; color:#86efac; font-weight:600; text-transform:uppercase; }
.sg-stat-right { flex-direction:row-reverse; }
.sg-title { font-size:.95rem; font-weight:800; color:#15803d; letter-spacing:.02em; }

.sg-level-bar {
  display:flex; align-items:center; gap:10px;
  padding:4px 16px;
  background:#f0fdf4; border-bottom:1px solid #dcfce7;
  flex-shrink:0;
}
.sg-level-txt { font-size:.65rem; font-weight:800; color:#16a34a; letter-spacing:.1em; min-width:60px; }
.sg-level-track { flex:1; height:4px; background:#bbf7d0; border-radius:4px; overflow:hidden; }
.sg-level-fill { height:100%; background:linear-gradient(90deg,#22c55e,#16a34a); border-radius:4px; transition:width .3s; }

.sg-board-wrap {
  flex:1; position:relative; overflow:hidden;
  display:flex; align-items:center; justify-content:center;
  background:#f0fdf4;
}
.sg-canvas { display:block; max-width:100%; max-height:100%; }

.sg-overlay {
  position:absolute; inset:0;
  display:flex; align-items:center; justify-content:center;
  background:rgba(240,253,244,0.92);
  backdrop-filter:blur(4px);
}
.sg-over-overlay { background:rgba(255,255,255,0.93); }
.sg-ov-card {
  display:flex; flex-direction:column; align-items:center; gap:10px;
  background:#fff; border:1.5px solid #bbf7d0;
  border-radius:20px; padding:28px 36px;
  box-shadow:0 8px 40px rgba(34,197,94,.15);
}
.sg-ov-emoji { font-size:3.2rem; }
.sg-ov-title { font-size:1.4rem; font-weight:800; color:#15803d; margin:0; }
.sg-ov-hint { font-size:.75rem; color:#86efac; margin:0; }
.sg-final-score { font-size:2.8rem; font-weight:900; color:#22c55e; line-height:1; }
.sg-final-score span { font-size:1rem; color:#86efac; font-weight:600; }
.sg-start-btn {
  margin-top:4px;
  background:linear-gradient(135deg,#22c55e,#16a34a);
  color:#fff; border:none; border-radius:12px;
  padding:12px 32px; font-size:.95rem; font-weight:800;
  cursor:pointer; letter-spacing:.03em;
  box-shadow:0 4px 16px rgba(34,197,94,.35);
  transition:transform .15s, box-shadow .15s;
}
.sg-start-btn:hover { transform:translateY(-2px); box-shadow:0 6px 20px rgba(34,197,94,.45); }

.sg-fade-enter-active,.sg-fade-leave-active { transition:opacity .25s; }
.sg-fade-enter,.sg-fade-leave-to { opacity:0; }

.sg-dpad {
  display:flex; flex-direction:column; align-items:center; gap:3px;
  padding:10px 0 12px;
  background:linear-gradient(180deg,#f9fafb,#f3f4f6);
  border-top:1px solid #e5e7eb; flex-shrink:0;
}
.sg-dpad-mid-row { display:flex; align-items:center; gap:3px; }
.sg-dpad-center { width:40px; height:40px; display:flex; align-items:center; justify-content:center; color:#d1d5db; font-size:1.2rem; }
.sg-dpad-btn {
  width:42px; height:42px;
  background:#fff; border:1.5px solid #e5e7eb; border-radius:10px;
  color:#374151; font-size:.9rem; cursor:pointer;
  box-shadow:0 2px 6px rgba(0,0,0,.06);
  transition:all .1s;
  display:flex; align-items:center; justify-content:center;
}
.sg-dpad-btn:hover { background:#f0fdf4; border-color:#22c55e; color:#15803d; }
.sg-dpad-btn:active { transform:scale(0.93); background:#dcfce7; }
</style>
